import { render } from "./InvitationPromotion.vue?vue&type=template&id=7ff0bc85&scoped=true"
import script from "./InvitationPromotion.vue?vue&type=script&lang=js"
export * from "./InvitationPromotion.vue?vue&type=script&lang=js"

import "./InvitationPromotion.vue?vue&type=style&index=0&id=7ff0bc85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff0bc85"]])

export default __exports__